var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 18H15.5M17 10.5C17 13.2614 14.7614 15.5 12 15.5M17 10.5C17 7.73858 14.7614 5.5 12 5.5M17 10.5H7M12 15.5C9.23858 15.5 7 13.2614 7 10.5M12 15.5C13.1046 15.5 14 13.2614 14 10.5C14 7.73858 13.1046 5.5 12 5.5M12 15.5C10.8954 15.5 10 13.2614 10 10.5C10 7.73858 10.8954 5.5 12 5.5M12 5.5C9.23858 5.5 7 7.73858 7 10.5M6 3H18C19.1046 3 20 3.89543 20 5V19C20 20.1046 19.1046 21 18 21H6C4.89543 21 4 20.1046 4 19V5C4 3.89543 4.89543 3 6 3Z",
    stroke: "#F2F5F8",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassport);
export default __webpack_public_path__ + "static/media/passport.38ff50d93a0677f2d8c68a4d2c674a4a.svg";
export { ForwardRef as ReactComponent };